import { FeatureFlags } from '@/featureFlags'
import { useFeatureFlag } from '@/hooks/useFeatureFlag'

export const useExhibitsAccess = (): boolean =>
  useFeatureFlag(FeatureFlags.CR_EXHIBITS)
